import { IPosIn } from "../../models/input/agendaApi/IPosIn";
import { ISaleIn } from "../../models/input/agendaApi/ISaleIn";
import * as ApiWithToken from "../callApiWithToken";


const posManagementService = {
    getClassListPos: async function(languageId:string){
        return  ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API +  `Pos/GetClassList?LanguageID=${languageId}`);
    },
    getStratificationListPos: async function(languageId:string){
        return  ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API +  `Pos/GetStratificationList?LanguageID=${languageId}`);
    },
    getPOSInformationListPos: async function(languageId:string){
        return  ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API +  `Pos/GetPOSInformationList?LanguageID=${languageId}`);
    },
    insertPOS:async function(posInsertIn: IPosIn){
        return ApiWithToken.postApi(process.env.REACT_APP_AGENDAS_API + `Pos/CreatePOS`, posInsertIn);
    },
    updatePOS:async function(posInsertIn: IPosIn){
        return ApiWithToken.putApi(process.env.REACT_APP_AGENDAS_API + `Pos/UpdatePOS`, posInsertIn);
    },
}
export default posManagementService;
